import { render, staticRenderFns } from "./NotificationPackingTypePopup.vue?vue&type=template&id=5c7706d7"
import script from "./NotificationPackingTypePopup.vue?vue&type=script&lang=js"
export * from "./NotificationPackingTypePopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports